import React from 'react'
import styled, { css } from 'styled-components'

export const FormLabel = styled.label<{ $alternative?: boolean }>`
    font-size: 1rem;
    line-height: 1.6rem;
    display: block;
    ${({ $alternative }) => $alternative ? css`
        color: ${props => props.theme.palette.text.label};
    ` : css`
        color: ${props => props.theme.palette.text.secondary};
    `}
    margin-bottom: 2px;
`